import { commonUtils } from './common_utils';

const BODY_TYPE_TRACTOR = 47;
const BIKE_TYPE_ATV_TRACTOR = 818742;
const BIKE_TYPE_TRACKER_ATV_OTHER = 818695;
const BIKE_TYPE_MOTORCYCLE = 818697;
const BIKE_TYPE_MOPED = 818825;
const BIKE_TYPE_SNOWSKI = 818696;
const insuranceOffer = {
    isTrackImpression: false,
    trackImpression() {
        // Get vehicle/body data from the insurance section data attributes
        let $section = $('#mainInsuranceSectionLarge');
        if (!$section.length) {
            $section = $('#mainInsuranceSectionSmall');
        }
        const vehicleId = $section.data('vehicle-id') || '';
        const bodyId = $section.data('body-id') || '';
        const viewSuffix = $('#mainInsuranceSectionLarge').length ? 'Large' : 'Small';

        if (!commonUtils.isDevEnvironment() && insuranceOffer.isTrackImpression === false) {
            // Use `globalThis.` because data is set after page load
            if (globalThis.$('#cmp_consent').data('allow-insurance-track')) {
                insuranceOffer.isTrackImpression = true;
                // If Set URL
                insuranceOffer.setIfInsuranceUrls(viewSuffix, vehicleId, bodyId);
                if ('Nettiauto' === commonUtils.getVerticalName()) {
                    let randomNumber = commonUtils.generateRandomNumber();
                    // Lähitapiola Set URL
                    $(`#insuranceNameLahitapiola${viewSuffix}`).data(
                        'url',
                        `https://track.adform.net/C/?bn=70433660&cachebuster=${randomNumber}`
                    );
                    // If impression tracker
                    let ifRedirectUrl =
                        'https://ad.doubleclick.net/ddm/trackimp/N709637.279382DBMAMNETIFNORDICS/B23264227.258878806;dc_trk_aid=454698568;dc_trk_cid=123540182;ord=%%CACHEBUSTER%%;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?';
                    insuranceOffer.setImpressionTracker(60259, ifRedirectUrl);

                    // Lähitapiola impression tracker
                    let LahitapiolaRedirectUrl = `https://track.adform.net/adfserve/?bn=70433660;1x1inv=1;srctype=3;ord=${Date.now()}`;
                    insuranceOffer.setImpressionTracker(60244, LahitapiolaRedirectUrl);

                    // Add Salesforce event for insurance calculator button in Nettiauto
                    let { Krux } = globalThis;
                    if (!Krux) {
                        Krux = function (...args) {
                            Krux.q.push(args);
                        };
                        Krux.q = [];
                        globalThis.Krux = Krux;
                    }
                    Krux('ns:almamedia', 'admEvent', 'OWnh13fR', {
                        event_type: 'default',
                    });
                } else {
                    // If impression tracker
                    let ifRedirectUrl =
                        'https://ad.doubleclick.net/ddm/trackimp/N709637.279382DBMAMNETIFNORDICS/B23387332.258900223;dc_trk_aid=454622982;dc_trk_cid=123649387;ord=%%CACHEBUSTER%%;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
                    insuranceOffer.setImpressionTracker(60257, ifRedirectUrl);
                }
            }

            // Datalayer event
            let insurances = [];
            $.each($section.find('.insuranceOfferButton'), function () {
                insurances.push($(this).data('name'));
            });
            if (insurances.length) {
                commonUtils.dataLayer.showInsuranceButtonDataLayerEvent(insurances);
            }
        }
    },
    setIfInsuranceUrls(viewSuffix, vehicleId, bodyId) {
        let motoVehicleTypeWiseId = {};
        if (commonUtils.isNettimoto()) {
            motoVehicleTypeWiseId = {
                2: BIKE_TYPE_MOTORCYCLE,
                6: BIKE_TYPE_SNOWSKI,
                5: BIKE_TYPE_MOPED,
                16: bodyId === BODY_TYPE_TRACTOR ? BIKE_TYPE_ATV_TRACTOR : BIKE_TYPE_TRACKER_ATV_OTHER,
            };
        }

        const randomNumber = commonUtils.generateRandomNumber();
        const trackerId = {
            Nettiauto: 818698,
            Nettivene: 818699,
            Nettimoto: motoVehicleTypeWiseId[vehicleId] || BIKE_TYPE_MOTORCYCLE,
        };

        $(`#insuranceNameIF${viewSuffix}`).data(
            'url',
            `https://secure.adnxs.com/clktrb?id=${trackerId[commonUtils.getVerticalName()]}&cachebuster=${randomNumber}&t=1`
        );
    },
    setImpressionTracker(pixelId, redirectUrl) {
        let randomNumber = commonUtils.generateRandomNumber();
        let pixelUrl = `https://secure.adnxs.com/imptr?id=${pixelId}&t=2`;

        if (redirectUrl !== '') {
            const cacheBustedUrl = redirectUrl.replace('%%CACHEBUSTER%%', randomNumber);
            pixelUrl += `&redir=${cacheBustedUrl}`;
        }

        const impressionImage = new Image();
        impressionImage.src = `${pixelUrl}&t=2&cachebuster=${randomNumber}`;
    },
};

$(function () {
    let $body = $('body');

    // Fire impression tracking on page load since insurance card is now expanded by default
    if ($('.insurance-banner__advertise').length) {
        insuranceOffer.trackImpression();
    }

    // On click get insurance button
    $body.on('click', '.insuranceOfferButton', function (e) {
        e.preventDefault();

        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }

        let insuranceName = $(this).data('name') || '';
        let url = $(this).data('url');
        if (!url) {
            return;
        }
        commonUtils.dataLayer.getInsuranceButtonDataLayerEvent(insuranceName);
        window.open(url, '_blank', 'noopener,noreferrer');
    });
});
